module.exports = __webpack_public_path__ + "f2cb577b58c4d31695d9c04e7bcf3b52.pdf";